import { create } from 'zustand';
import { feedbackUngelesen } from '../lib/planung';

/** Zahl neuer Rückmeldungen von Ansprechpersonen (Seitenleiste „Geplante Mails"). */
interface FeedbackStore {
  anzahl: number;
  laden: () => Promise<void>;
}

export const useFeedbackStore = create<FeedbackStore>((set) => ({
  anzahl: 0,
  laden: async () => {
    try {
      set({ anzahl: await feedbackUngelesen() });
    } catch {
      // Die Zahl ist nur ein Hinweis — ohne sie geht es auch.
    }
  },
}));
